import React, { useState, useEffect, useRef, useCallback } from "react";

import {
    Box,
    Badge,
    Paper,
    TextField,
    Grid,
    styled,
    Card,
    Divider,
    IconButton,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Table,
    TableCell,
    TableContainer,
    TableBody,
    TableHead,
    TableRow,
    Fab,
    Link,
    Tooltip
} from '@mui/material';

import {
    DataGrid,
    GridColDef,
    GridToolbar,
    GridCellParams,
    useGridApiContext,
    GridCellEditStopReasons
} from '@mui/x-data-grid';

import { grey } from "@mui/material/colors";

import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator } from "@mui/lab";

import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { StaticDateTimePicker } from '@mui/x-date-pickers/StaticDateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import dayjs from "dayjs";

import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useFormik } from 'formik';
import { useSystemPrompt } from "../../../../../hooks/useSystemPrompt";

import { useSystemRoutes, routeTypes } from '../../../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../../../hooks/usePermissions";
import { useTranslations } from "../../../../../hooks/useTranslations";

import { useAppContextFeatures } from "../../../../../context/AppContext";
import { useAuthAccess } from "../../../../../hooks/useAuthAccess";

import CommonBreadcumbs from '../../../../../components/common/CommonBreadcumbs';
import CommonSectionHeader from "../../../../../components/common/CommonSectionHeader";
import CommonRestricted from '../../../../../components/common/CommonRestricted';
import { CommonIcons, icons } from "../../../../../components/common/CommonIcons";

import { useContainer, validationSchema, containerInjectionProps, containerInjectionFields, containerTypes } from "../../../hooks/model/useContainer";
import { useContainerItem } from "../../../hooks/model/useContainerItem";
import { usePackingExcelExport } from "../../../hooks/usePackingExcelExport"
import { useProduct, productInjectionProps, productLoadStatusTypes, productInjectionFields } from "../../../hooks/model/useProduct";
import { itemInjectionProps } from "../../../hooks/model/useProductItem";
import { useContainerPod } from "../../../hooks/sdgroupApi/useContainerPod"

import UpdateContainerInformation from "./section/UpdateContainerInformation";
import AddContainerItems from "./section/AddContainerItems";
// import ViewContainerItem from "./section/ViewContainerItem";

import { getInjectionDataType } from "../../../utils/injectionSelection";

import { formatRoundValue } from "../../../utils/formatNumber"

// const useStyles = makeStyles(theme => ({
//     link: {
//         '&:hover': {
//             textDecorationStyle: 'dotted'
//         }
//     },
// }));

const _loadContainerDateTimeFormat = "YYYY-MM-DD HH:mm:ss"

const StyledLink = styled(Link)(({ theme }) => ({
    '&:hover': {
        textDecorationStyle: 'dotted'
    }
}));

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    border: 1,
    // color:
    //     theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.85)',
    // fontFamily: [
    //     '-apple-system',
    //     'BlinkMacSystemFont',
    //     '"Segoe UI"',
    //     'Roboto',
    //     '"Helvetica Neue"',
    //     'Arial',
    //     'sans-serif',
    //     '"Apple Color Emoji"',
    //     '"Segoe UI Emoji"',
    //     '"Segoe UI Symbol"',
    // ].join(','),
    // WebkitFontSmoothing: 'auto',
    // letterSpacing: 'normal',
    '& .MuiDataGrid-columnsContainer': {
        backgroundColor: theme.palette.mode === 'light' ? '#fafafa' : '#1d1d1d',
    },
    // '& .MuiDataGrid-iconSeparator': {
    //     display: 'none',
    // },
    '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
        borderRight: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'
            }`,
    },
    '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
        borderBottom: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'
            }`,
    },
    '& .MuiDataGrid-cell': {
        color: `black !important`,
        // color:
        //     theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.65)',
    },
    // '& .MuiPaginationItem-root': {
    //     borderRadius: 0,
    // },
    // ...customCheckbox(theme),
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});


const RenderFormContainer = ({ t, formik, handleUpdateContainerInformation, handleProofDelivery }) => {

    const { values } = formik

    let _containerTypeLabel = values?.containerType

    // console.log('_containerTypeLabel, _containerTypeLabel', _containerTypeLabel)

    if (_containerTypeLabel === containerTypes.mixedLCL.display) {
        _containerTypeLabel = containerTypes.mixedLCL.id
    }

    if (_containerTypeLabel === containerTypes.fullFCL.display) {
        _containerTypeLabel = containerTypes.fullFCL.id
    }

    if (_containerTypeLabel === containerTypes.shipLCL.display) {
        _containerTypeLabel = containerTypes.shipLCL.id
    }

    _containerTypeLabel = t(_containerTypeLabel)

    return (
        <StyledCard sx={{ mt: 1 }}>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={2} textAlign={"left"}>

                    <CommonSectionHeader
                        title={t('container')}
                        subTitle={t('registeredContainerInformation')}
                    />

                    {/* {
                            values?.packingFile?.download_url &&
                            <Link
                                href={values?.packingFile?.download_url}
                                target="_blank"
                            >
                                Download File
                            </Link>

                        } */}

                    {/* {JSON.stringify(values?.packingFile)} */}

                </Grid>
                <Grid item xs={12} sm={12} md={10}>

                    <TableContainer
                    >
                        <Table
                            // sx={{ minWidth: 650 }} 
                            sx={{
                                "& .MuiTableCell-root": {
                                    border: "1px solid rgba(224, 224, 224, 1)",
                                    color: `black !important`,
                                }
                            }}
                            size="small"
                            aria-label="a dense table"
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell colSpan={2}>{t('locationName')}</TableCell>
                                    <TableCell colSpan={2}>{t('destinationLocation')}</TableCell>
                                    <TableCell colSpan={2}>
                                        {t('action')}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={2}>{values?.locationName}</TableCell>
                                    <TableCell colSpan={2}>{values?.toLocationName}</TableCell>
                                    <TableCell colSpan={2}>
                                        <Box
                                            display={'flex'}
                                            flexDirection={'row'}
                                            justifyContent={'space-between'}
                                            alignItems={'flex-start'}
                                            alignSelf={"center"}
                                        >
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                size="small"
                                                startIcon={<CommonIcons name={icons.edit} />}
                                                fullWidth
                                                onClick={handleUpdateContainerInformation}
                                                sx={{ mr: 1 }}
                                            >
                                                {t('modify')}
                                            </Button>
                                            <Button
                                                color="warning"
                                                variant="contained"
                                                size="small"
                                                fullWidth
                                                onClick={handleProofDelivery}
                                            >
                                                {t('proofOfDelivery')}
                                            </Button>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            </TableBody>

                            <TableHead>
                                <TableRow>
                                    <TableCell colSpan={3}>{t('containerSize')}</TableCell>
                                    <TableCell colSpan={3}>{t('containerType')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={3}>{values?.containerSize}</TableCell>
                                    <TableCell colSpan={3}>{_containerTypeLabel}</TableCell>
                                </TableRow>
                            </TableBody>

                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('containerNo')}</TableCell>
                                    <TableCell>{t('secondaryNo')}</TableCell>
                                    <TableCell>{t('sealNo')}</TableCell>
                                    <TableCell>{t('repositoryMarking')}</TableCell>
                                    <TableCell>{t('initialDate')}</TableCell>
                                    <TableCell>{t('loadDate')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>{values?.repoNumber}</TableCell>
                                    <TableCell>{values?.repoAlternativeNumber}</TableCell>
                                    <TableCell>{values?.numberSeal}</TableCell>
                                    <TableCell>{values?.repoMarking}</TableCell>
                                    <TableCell>{values?.initialDate ? dayjs(values.initialDate).format(`YYYY-MM-DD`) : ''}</TableCell>
                                    <TableCell>{values?.loadDate ? dayjs(values.loadDate).format(`YYYY-MM-DD`) : ''}</TableCell>
                                </TableRow>
                            </TableBody>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('supervisor')}</TableCell>
                                    <TableCell>{t('shipper')}</TableCell>
                                    <TableCell>{t('customAgent')}</TableCell>
                                    <TableCell colSpan={3}>{t('remark')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>{values?.supervisor}</TableCell>
                                    <TableCell>{values?.shipper}</TableCell>
                                    <TableCell>{values?.customAgent}</TableCell>
                                    <TableCell colSpan={4}>{values?.remark ? values.remark : '-'}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>

                </Grid>
            </Grid>
        </StyledCard>

    )
}

const RenderItems = ({ t, selectedIds, dataItems, columns, handleRowSelectionModelChange }) => {

    if (!dataItems) return <></>

    const rows = dataItems

    // console.log('dataItems', dataItems)

    // const _columns = getColumns()

    return (
        <Box
            // sx={{
            //     '& .my-super-theme--naming-group': {
            //         backgroundColor: grey[800],
            //         color: grey[100]
            //     },
            // }}
            sx={{
                // height: 450,
                width: '100%'
            }}
        >
            <StyledDataGrid
                rows={rows}
                columns={columns}
                header
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: 100 },
                    },
                }}
                pageSizeOptions={[100]}
                checkboxSelection

                disableColumnFilter
                disableColumnSelector
                disableDensitySelector
                disableColumnMenu={Boolean(true)}

                density="compact"

                slots={{ toolbar: GridToolbar }}
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                    },
                }}
                disableRowSelectionOnClick
                rowSelectionModel={selectedIds}
                onRowSelectionModelChange={handleRowSelectionModelChange}

            />
        </Box>
    )
}

export default function ModifyContainer({
    routeType
}) {

    const { t } = useTranslations({ ns: ["_@repositories", "_prompt", "_@products", "common", "_common"] })

    const { id } = useParams();

    const { authData } = useAuthAccess(routeType);
    // const availableLocations = getAvailableLocations();

    const authDataUserId = `${authData?.profile?.user?.id}`
    const authDataUserDisplay = `${authData?.profile?.user?.username}`

    const { promptMessage } = useSystemPrompt();
    const { setSystemLoading, openCustomDrawer, closeCustomDrawer } = useAppContextFeatures();

    const { getContainer, filterOperatorTypes } = useContainer({ routeType })
    const { deleteContainerItems } = useContainerItem({ routeType })
    const {
        listProducts,
        updateProductRemark,
        updateProductLoadContainerDateTime,
        sortProductsByGroupMarking,
        updateLastUpdateProduct
    } = useProduct({ routeType })

    const { isPermissionAllow } = usePermissions(routeType, scopeIds.repository.id, scopeTypes.repository.container.id)

    const { getContainerPods } = useContainerPod({ routeType })

    const [selectedIds, setSelectedIds] = useState([])

    const { generateExcel } = usePackingExcelExport({ routeType })

    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const [savedValues, setSavedValues] = useState()

    const [dataItems, setDataItems] = useState([])
    const [dataGrand, setDataGrand] = useState({})
    const [dataContainer, setDataContainer] = useState({})
    const [dataContainerPod, setDataContainerPod] = useState([])

    const [dialogOpen, setDialogOpen] = useState(false)
    const [dialogParams, setDialogParams] = useState({})

    const [dialogLoadContainerDTOpen, setDialogLoadContainerDTOpen] = useState(false)
    const [dialogLoadContainerDTParams, setDialogLoadContainerDTParams] = useState({})
    const [proofOfDeliveryDialog, setProofOfDeliveryDialog] = useState(false)

    const loadData = async (id) => {

        setSystemLoading(true)

        try {

            const data = await getContainer({ id })

            const {
                repository,
                // items, 
                // packing_file: packingFile 
            } = data;

            let products = await fetchProductsByContainerId({ containerId: id })

            // have to sequence the items group by the marking togather
            // console.log('products', products)

            // let _sequences = []
            // let _finalProducts = []
            // let _skipIds = []
            // let _relatedItems = []

            let a = sortProductsByGroupMarking({ products })

            let _finalProducts = a.finalProducts
            let _skipIds = a.skipIds
            let _relatedItems = a.relatedItems

            products = _finalProducts

            let relatedItems = _relatedItems

            let grand = {
                packQty: 0,
                values: 0,
                weight: 0,
                cbm: 0
            }
            let rows = []

            products.forEach(i => {

                let totalPackQty = 0;
                let totalCbm = 0
                let totalValues = 0
                let totalWeight = 0

                i?.items.forEach(i2 => {

                    let itemId = i2?.id

                    let _a_ = relatedItems.filter(i3 => i3?.id === itemId)
                    let a = _a_.length > 0 ? _a_[0] : {}

                    totalPackQty += parseFloat(a[itemInjectionProps.packQty.retrieveKey])
                    totalCbm += parseFloat(a[itemInjectionProps.totalCbm.retrieveKey])
                    totalValues += parseFloat(a[itemInjectionProps.totalValue.retrieveKey])
                    totalWeight += parseFloat(a[itemInjectionProps.totalWeight.retrieveKey])

                })

                totalPackQty = totalPackQty.toFixed(0)
                totalCbm = totalCbm.toFixed(4)
                totalValues = totalValues.toFixed(2)
                totalWeight = totalWeight.toFixed(4)

                rows.push({
                    ...i,
                    calculated: {
                        totalPackQty,
                        totalCbm,
                        totalValues,
                        totalWeight
                    }
                })

                grand = {
                    ...grand,
                    cbm: parseFloat(totalCbm) + grand?.cbm,
                    weight: parseFloat(totalWeight) + grand?.weight,
                    values: parseFloat(totalValues) + grand?.values,
                    packQty: parseFloat(totalPackQty) + grand?.packQty,
                }

            })

            let _grand = {
                cbm: grand.cbm.toFixed(4),
                weight: grand.weight.toFixed(4),
                values: grand.values.toFixed(2),
                packQty: grand.packQty.toFixed(0),
            }


            // console.log('rows', repository)

            // let rows = items
            // resultGroups

            setDataGrand(_grand)

            setDataContainer(repository)

            // await fetchContainerPod({
            //     containerRemId: repository[containerInjectionFields.sourceContainerRemId.retrieveKey]
            // })

            setSavedValues({
                // ...initialValues,
                locationId: repository?.location_id,
                locationName: repository?.location_name,
                toLocationId: repository?.to_location_id,
                toLocationName: repository?.to_location_name,
                repoNumber: repository?.repo_number,
                repoAlternativeNumber: repository?.number_alternative,
                numberSeal: repository?.number_seal,
                repoMarking: repository?.number_marking,
                initialDate: dayjs(repository?.repo_date),
                loadDate: dayjs(repository?.load_date),
                supervisor: repository?.supervisor,
                shipper: repository?.shipper,
                customAgent: repository?.custom_agent,
                remark: repository?.remark ? repository.remark : "",
                containerSize: repository[containerInjectionProps.containerSize.retrieveKey],
                containerType: repository[containerInjectionProps.containerType.retrieveKey],
                sourceContainerRemId: repository[containerInjectionProps.sourceContainerRemId.retrieveKey],
                // ...initialRowValues,
                // packingFile,
                rows,
            })

            // prompt error is empty container source remid
            if (!repository[containerInjectionProps.sourceContainerRemId.retrieveKey]) {
                promptMessage(false, `sourceContainerRemId is empty`)
            }


            // console.log('itemIds', itemIds)

            // console.log('products', products)
            setDataItems(rows)
            // setDataItems(finalRows)
            // setRelatedItems(relatedItems)


        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }

    const fetchProductsByContainerId = async ({ containerId }) => {

        try {

            let dataTypes = [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`]

            const props = {
                limit: -1,
                skip: 0,
                filterValue: [{
                    name: productInjectionProps.loadContainerId.retrieveKey,
                    operator: filterOperatorTypes.eq,
                    value: containerId
                }],
                sortInfo: {
                    // id: "id",
                    id: productInjectionProps.loadContainerDateTime.retrieveKey,
                    dir: 0
                }
            }

            // props.itemType = itemTypes.product

            // const result = await listItems(props)
            const { data } = await listProducts({ props, dataTypes })

            // return result?.data?.products ? result.data.products : []
            return data

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        return false

    }

    const updateProductRemarkIP = async ({ productId, remark }) => {

        setSystemLoading(true)

        try {

            await updateProductRemark({
                productId,
                remark
            })

            let _p = {
                productId,
                lastUpdateUserId: authDataUserId,
                lastUpdateUserDisplay: authDataUserDisplay
            }

            await updateLastUpdateProduct(_p)

            setSystemLoading(false)

            promptMessage(true, `Remark has been saved`)

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }


        setSystemLoading(false)

        return false

    }

    const updateProductLoadContainerDT = async ({ productId, sourceProductRemId, sourceContainerRemId, loadContainerDateTime }) => {

        setSystemLoading(true)

        try {

            await updateProductLoadContainerDateTime({
                productId,
                sourceProductRemId,
                sourceContainerRemId,
                loadContainerDateTime
            })

            // let _p = {
            //     productId,
            //     lastUpdateUserId: authDataUserId,
            //     lastUpdateUserDisplay: authDataUserDisplay
            // }

            // await updateLastUpdateProduct(_p)

            setSystemLoading(false)

            promptMessage(true, `Remark has been saved`)

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }


        setSystemLoading(false)

        return false

    }

    const formik = useFormik({
        initialValues: savedValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit: () => { }
    });

    const { values, errors, touched, handleChange, setFieldValue, handleSubmit } = formik;

    useEffect(() => {

        loadData(id);

    }, [])

    const handleDeleteContainerItems = async ({ selectedProductIds }) => {

        setSystemLoading(true)

        try {

            // let rows = values?.rows

            // console.log('se', rows, selectedProductIds)

            await deleteContainerItems({
                productIds: selectedProductIds,
                containerId: id,
                sourceContainerRemId: values?.sourceContainerRemId
            })

            // await Promise.all(selectedProductIds.map(async (i) => {

            //     let _p = {
            //         productId: i,
            //         lastUpdateUserId: authDataUserId,
            //         lastUpdateUserDisplay: authDataUserDisplay
            //     }

            //     await updateLastUpdateProduct(_p)

            // }));

            promptMessage(true, `${t("removeFromContainerSuccess")}`)

            setSystemLoading(false)

            await loadData(id);

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }

    const handleUpdateContainerInformation = () => {

        openCustomDrawer({
            show: true,
            anchor: "right",
            title: t('updateContainerInformation'),
            PaperProps: {
                sx: { width: 2 / 3 }
            },
            handleOnClose: () => {
                // closeConfirmUpload()
            },
            ComponentActions:
                <></>,
            ComponentBody:
                <UpdateContainerInformation
                    routeType={routeType}
                    containerId={id}
                    handleOnSuccess={() => {
                        closeCustomDrawer()
                        // closeConfirmUpload()
                        // console.log('drawer closed', id)
                        loadData(id);
                    }}
                />
        })
    }

    const handleAddContainerItems = () => {

        openCustomDrawer({
            show: true,
            anchor: "right",
            title: t('addContainerItems'),
            PaperProps: {
                // sx: { width: 9 / 10 }
                sx: { width: "95%" }
            },
            handleOnClose: () => {
                // closeConfirmUpload()
                loadData(id);
            },
            ComponentActions:
                <></>,
            ComponentBody:
                <AddContainerItems
                    routeType={routeType}
                    containerId={id}
                    handleOnSuccess={() => {
                        console.log('success')
                        // closeCustomDrawer()
                        // closeConfirmUpload()
                        // console.log('drawer closed', id)
                        // loadData(id);
                    }}
                />
        })
    }

    const handleExportPackingExcelFull = async () => {

        let items = dataItems

        setSystemLoading(true)

        try {

            await generateExcel({
                container: dataContainer,
                items,
                config: {
                    generateFileName: `${savedValues?.repoNumber}-FULL.xlsx`
                }
            })

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const handleExportPackingExcelSimple = async () => {

        let items = dataItems

        setSystemLoading(true)

        try {

            await generateExcel({
                container: dataContainer,
                items,
                config: {
                    generateFileName: `${savedValues?.repoNumber}-SIMPLE.xlsx`
                },
                isSimpleMode: true
            })

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const handleCloseProofDeliveryDialog = () => {
        setProofOfDeliveryDialog(false);
    };

    const handleProofDeliveryDialog = async () => {

        setSystemLoading(true)

        try {

            const data = await getContainerPods({ containerRemId: dataContainer[containerInjectionFields.sourceContainerRemId.retrieveKey] })

            setDataContainerPod(data)
            setProofOfDeliveryDialog(true);

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    };

    const getColumns = () => {

        return [
            // {
            //     field: 'id',
            //     headerName: 'PId',
            //     // headerClassName: 'my-super-theme--naming-group',
            //     // width: 130
            // },
            {
                field: productInjectionProps.customerMarking.retrieveKey,
                headerName: t('marking'),
                // headerClassName: 'my-super-theme--naming-group',
                width: 140,
                sortable: false,
                renderCell: (params) => {
                    // console.log('params', params)
                    return (
                        <Link
                            sx={{
                                fontWeight: '800',
                                fontSize: 13,
                            }}
                            href={
                                getRoute(`product/item/update/${params?.row?.id}`)
                            }
                            target="_blank"
                        >
                            {params.value}
                        </Link>
                    )
                }
            },
            {
                field: productInjectionProps.courierTrackingNo.retrieveKey,
                headerName: t('courierNo'),
                // headerClassName: 'my-super-theme--naming-group',
                sortable: false,
                width: 140,
                // renderCell: (params) => {
                //     // console.log('params', params)
                //     return (
                //         <Link
                //             sx={{
                //                 fontWeight: '800'
                //             }}
                //             href={
                //                 getRoute(`product/item/update/${params?.row?.id}`)
                //             }
                //             target="_blank"
                //         >
                //             {params.value}
                //         </Link>
                //     )
                // }
            },
            {
                field: productInjectionProps.supplierName.retrieveKey,
                headerName: t('supplier'),
                // headerClassName: 'my-super-theme--naming-group',
                sortable: false,
                width: 130,
                valueGetter: ({ value, row }) => {
                    // return `${value} (${row[productInjectionProps.supplierName.retrieveKey]})`
                    return `${value}`
                }
            },
            // {
            //     field: 'supplierContact',
            //     headerName: 'Supplier Contact',
            //     // headerClassName: 'my-super-theme--naming-group',
            //     // width: 130
            // },
            {
                field: productInjectionProps.supplierPurchaseNumber.retrieveKey,
                headerName: t('purchaseNo'),
                // headerClassName: 'my-super-theme--naming-group',
                sortable: false,
                width: 120,
                valueGetter: ({ value, row }) => {
                    return `${value} (${row[productInjectionProps.companyPurchaseNumber.retrieveKey]})`
                }
            },
            // {
            //     field: 'companyPurchaseNumber',
            //     headerName: 'Company PNo.',
            //     // headerClassName: 'my-super-theme--naming-group',
            //     // width: 130
            // },
            {
                field: productInjectionProps.remark.retrieveKey,
                headerName: t('remark'),
                // editable: true,
                // type: 'string',
                width: 120,
                sortable: false,
                // valueGetter: ({ value, row }) => {
                //     return `${value}`
                // },
                renderCell: (params) => {

                    let value = params?.row[productInjectionProps.remark.retrieveKey]

                    // let path = getRoute(`documents/deliveryOrder/view/${params.row?.id}`);

                    return (
                        <Tooltip
                            title={value}
                        >
                            <Box
                                display={"flex"}
                                flexDirection={"row"}
                                justifyContent={"flex-start"}
                                alignItems={"center"}
                            >

                                <IconButton
                                    color="primary"
                                    onClick={() => {
                                        setDialogOpen(true)
                                        setDialogParams({
                                            productId: params.row?.id,
                                            remark: value
                                        })
                                    }}
                                >
                                    <CommonIcons name={icons.edit} />
                                </IconButton>
                                <Typography
                                    sx={{
                                        fontSize: 13
                                    }}
                                >
                                    {value}
                                </Typography>
                            </Box>
                        </Tooltip>
                    )
                },
                // renderEditCell: (params) => {

                //     let _params = params

                //     // add in more information

                //     return (
                //         <EditTextarea {..._params} />
                //     )
                // },
                // headerClassName: 'my-super-theme--naming-group',
                // width: 130
            },
            // {
            //     field: 'totalHandleQty',
            //     align: 'right',
            //     headerAlign: "right",
            //     headerName: 'Handle Qty',
            //     // headerClassName: 'my-super-theme--naming-group',
            //     // width: 130
            // },
            {
                field: 'totalQty',
                align: 'right',
                headerAlign: "right",
                headerName: t('packQty'),
                sortable: false,
                // headerClassName: 'my-super-theme--naming-group',
                width: 90,
                valueGetter: ({ value, row }) => {
                    return `${row?.calculated?.totalPackQty}`
                }
                // renderCell: (params) => {

                //     let totalPackQty = 0

                //     params?.items?.filter((total, item) => {

                //         let selectedItem = relatedItems.filter(i => i?.id === item?.id)

                //         if (selectedItem.length > 0) {
                //             total += parseFloat(selectedItem[0][itemInjectionProps.packQty.retrieveKey])
                //         }

                //         return total

                //     }, 0)

                //     totalPackQty = parseFloat(totalPackQty).toFixed(0)

                //     // console.log('params', params)
                //     return (
                //         <>
                //             {totalPackQty}
                //         </>
                //         // <Button
                //         //     fullWidth
                //         //     type="button"
                //         //     variant="outlined"
                //         //     color="primary"
                //         //     size="small"
                //         //     onClick={() => {
                //         //         handleViewContainerItems({
                //         //             courierTrackingNo: params.row?.courierTrackingNo,
                //         //             productId: params.row?.id,
                //         //             dataItems
                //         //         })
                //         //     }}
                //         // >
                //         //     {/* {params.value} / {params?.row?.totalOriPackUnit} */}

                //         // </Button>
                //     )
                // }
            },
            {
                field: 'totalCbm',
                align: 'right',
                headerAlign: "right",
                headerName: t('cbm'),
                width: 80,
                sortable: false,
                renderCell: ({ row }) => {

                    // return `${row?.calculated?.totalCbm} (${parseFloat(row?.calculated?.totalCbm).toFixed(3)})`
                    return (
                        <Tooltip
                            title={`Original : ${row?.calculated?.totalCbm}`}
                        >
                            <Typography
                                sx={{
                                    fontSize: 13
                                }}
                            >
                                {
                                    `${formatRoundValue(row?.calculated?.totalCbm, 3).toFixed(3)}`
                                }
                            </Typography>
                        </Tooltip>
                    )

                },
                // headerClassName: 'my-super-theme--naming-group',
                // width: 110
            },
            {
                field: 'totalValues',
                align: 'right',
                headerAlign: "right",
                headerName: t('values'),
                sortable: false,
                valueGetter: ({ value, row }) => {
                    return `${row?.calculated?.totalValues}`
                }
                // headerClassName: 'my-super-theme--naming-group',
                // width: 130
            },
            // {
            //     field: 'totalValue',
            //     align: 'right',
            //     headerAlign: "right",
            //     headerName: 'Value',
            //     // headerClassName: 'my-super-theme--naming-group',
            //     // width: 130
            // },
            {
                field: 'totalWeight',
                align: 'right',
                headerAlign: "right",
                headerName: t('weight'),
                sortable: false,
                width: 80,
                // valueGetter: ({ value, row }) => {
                //     // return `${parseFloat(row?.calculated?.totalWeight).toFixed(4)}`
                //     return `${}`
                // },
                renderCell: ({ row }) => {

                    // return `${row?.calculated?.totalCbm} (${parseFloat(row?.calculated?.totalCbm).toFixed(3)})`
                    return (
                        <Tooltip
                            title={`Original : ${row?.calculated?.totalWeight}`}
                        >
                            <Typography
                                sx={{
                                    fontSize: 13
                                }}
                            >
                                {
                                    `${formatRoundValue(row?.calculated?.totalWeight, 3).toFixed(3)}`
                                }
                            </Typography>
                        </Tooltip>
                    )

                },
                // headerClassName: 'my-super-theme--naming-group',
                // width: 130
            },
            {
                field: productInjectionProps.signedByUserDisplay.retrieveKey,
                headerName: t('signedBy'),
                width: 90,
                sortable: false,
                // headerClassName: 'my-super-theme--naming-group',
                // width: 130
            },
            {
                field: productInjectionProps.loadContainerDateTime.retrieveKey,
                headerName: t('loadDateTime'),
                // headerClassName: 'my-super-theme--naming-group',
                align: 'center',
                headerAlign: "center",
                width: 150,
                sortable: true,
                // valueGetter: ({ value, row }) => {

                //     let _val = value ? dayjs(value).format("YYYY/MM/DD HH:mm:ss A") : ""

                //     return `${_val}`
                // }
                renderCell: (params) => {

                    let _val = params.row[productInjectionProps.loadContainerDateTime.retrieveKey] ?
                        params.row[productInjectionProps.loadContainerDateTime.retrieveKey]
                        :
                        ``

                    // console.log('params.row', params.row)

                    return (
                        <StyledLink
                            underline="hover"
                            href=""
                            // className={classes.link}
                            onClick={(e) => {
                                e.preventDefault()

                                setDialogLoadContainerDTOpen(true)
                                setDialogLoadContainerDTParams({
                                    productId: params.row?.id,
                                    sourceProductRemId: params.row[productInjectionFields.sourceProductRemId.retrieveKey],
                                    sourceContainerRemId: dataContainer[containerInjectionFields.sourceContainerRemId.retrieveKey],
                                    loadContainerDateTime: _val
                                })

                            }}
                        >
                            {
                                _val ?
                                    (
                                        <Typography
                                            sx={{
                                                fontSize: 13
                                            }}
                                        >
                                            {_val}
                                        </Typography>
                                    )
                                    :
                                    (
                                        <CommonIcons name={icons.edit} sx={{ height: 18, width: 18 }} />
                                    )
                            }
                        </StyledLink>
                        // <Typography
                        //     sx={{
                        //         fontSize: 12
                        //     }}
                        // >
                        //     {_val}
                        // </Typography>
                    )
                }
            },
            {
                field: `ax_createdatetime`,
                headerName: `${t('createdatetime')}`,
                // headerClassName: 'my-super-theme--naming-group',
                align: 'center',
                headerAlign: "center",
                width: 120,
                sortable: true,
                // valueGetter: ({ value, row }) => {

                //     let _val = value ? dayjs(value).format("DD MMM HH:mm A") : ""

                //     return `${_val}`
                // }
                renderCell: (params) => {

                    let createdAt = params.row?.ax_createdatetime ?
                        dayjs(params.row.ax_createdatetime).format("DD MMM HH:mm A")
                        :
                        ""

                    return (
                        <Typography
                            sx={{
                                fontSize: 12
                            }}
                        >
                            {`${createdAt}`}
                        </Typography>
                    )
                }
            },
            {
                field: `${productInjectionFields.checkinDateTime.retrieveKey}`,
                headerName: `${t('checkedInAt')}`,
                // headerClassName: 'my-super-theme--naming-group',
                align: 'center',
                headerAlign: "center",
                width: 130,
                sortable: true,
                renderCell: (params) => {

                    let checkinDateTime = params.row[productInjectionFields.checkinDateTime.retrieveKey]

                    return (
                        <Typography
                            sx={{
                                fontSize: 12
                            }}
                        >
                            {`${checkinDateTime}`}
                        </Typography>
                    )
                }
            },
            {
                field: `${productInjectionFields.barcode.retrieveKey}`,
                headerName: `${t('barcode')}`,
                align: 'center',
                headerAlign: "center",
                width: 160,
                sortable: true,
                renderCell: (params) => {

                    let barcodeRow = params.row[productInjectionFields.barcode.retrieveKey]

                    return (
                        <Typography
                            sx={{
                                fontSize: 12
                            }}
                        >
                            {`${barcodeRow}`}
                        </Typography>
                    )
                }
            }
        ];
    }

    return (
        <Box
            sx={{
                // pb: 5,
                mb: 20
            }}
        >
            {
                getHtmlHead({
                    routeType,
                    // title: headTitles.updateContainer 
                    title: t('modifyContainer')
                })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t('modifyContainer')}
                breadcrumbs={[
                    {
                        displayText: t('containers'),
                        props: {
                            href: getRoute(`repositories/containers`)
                        }
                    },
                    {
                        displayText: `${t('modifyContainer')} (*)`,
                        props: {
                            color: 'secondary.main'
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) ?
                    (
                        <form onSubmit={handleSubmit}>

                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                                    <RenderFormContainer
                                        t={t}
                                        formik={formik}
                                        handleUpdateContainerInformation={handleUpdateContainerInformation}
                                        handleProofDelivery={handleProofDeliveryDialog}
                                    />

                                </Grid>
                            </Grid>

                            <Box
                                sx={{
                                    px: 1,
                                    mt: 1
                                }}
                            >
                                <Grid container rowSpacing={0}>
                                    <Grid item xs={12} sm={12} md={2}
                                        display={"flex"}
                                        justifyContent={"flex-start"}
                                        alignItems={"center"}
                                    >

                                        <CommonSectionHeader
                                            title={t('items')}
                                            subTitle={t('detailInformationAboutTheItemsInvolved')}
                                        />

                                    </Grid>

                                    <Grid item xs={12} sm={12} md={4}

                                        display={"flex"}
                                        justifyContent={"flex-end"}
                                        alignItems={"center"}
                                    >
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleExportPackingExcelFull}
                                            sx={{
                                                mr: 1
                                            }}
                                        >
                                            {t('downloadPackingExcelFull')}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleExportPackingExcelSimple}
                                            sx={{
                                                mr: 1
                                            }}
                                        >
                                            {t('downloadPackingExcelSimple')}
                                        </Button>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={6} textAlign={"right"}>
                                        {/* {JSON.stringify(dataGrand)} */}

                                        <TableContainer
                                        >
                                            <Table
                                                // sx={{ minWidth: 650 }} 
                                                sx={{
                                                    "& .MuiTableCell-root": {
                                                        border: "1px solid rgba(224, 224, 224, 1)"
                                                    },
                                                    backgroundColor: '#fff',
                                                    my: 1
                                                }}
                                                size="small"
                                                aria-label="a dense table"
                                            >

                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="right">{t('totalPackQty')}</TableCell>
                                                        <TableCell align="right">{t('totalValues')}</TableCell>
                                                        <TableCell align="right">{t('totalWeight')}</TableCell>
                                                        <TableCell align="right">{t('totalCbm')}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell align="right">
                                                            <Tooltip
                                                                title={dataContainer[containerInjectionFields.totalPackQty.retrieveKey]}
                                                                placement="bottom-end"
                                                            >
                                                                <Typography sx={{ fontSize: 15 }}>
                                                                    {dataGrand?.packQty}
                                                                </Typography>
                                                            </Tooltip>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Tooltip
                                                                title={dataContainer[containerInjectionFields.totalValue.retrieveKey]}
                                                                placement="bottom-end"
                                                            >
                                                                <Typography sx={{ fontSize: 15 }}>
                                                                    {dataGrand?.values}
                                                                </Typography>
                                                            </Tooltip>

                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Tooltip
                                                                title={dataContainer[containerInjectionFields.totalWeight.retrieveKey]}
                                                                placement="bottom-end"
                                                            >
                                                                <Typography sx={{ fontSize: 15 }}>
                                                                    {dataGrand?.weight}
                                                                </Typography>
                                                            </Tooltip>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Tooltip
                                                                title={dataContainer[containerInjectionFields.totalCbm.retrieveKey]}
                                                                placement="bottom-end"
                                                            >
                                                                <Typography sx={{ fontSize: 15 }}>
                                                                    {dataGrand?.cbm}
                                                                </Typography>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </Grid>

                                </Grid>
                            </Box>

                            <StyledCard
                                sx={{
                                    p: 0
                                }}
                            >
                                <RenderItems
                                    t={t}
                                    selectedIds={selectedIds}
                                    dataItems={dataItems}
                                    columns={getColumns()}
                                    handleRowSelectionModelChange={(ids) => {
                                        // console.log('props', ids)

                                        // const selectedIDs = new Set(ids);
                                        // const selectedRowData = rows.filter((row) => selectedIDs.has(row.id.toString()))

                                        // console.log(selectedRowData);

                                        setSelectedIds(ids)
                                    }}
                                />
                            </StyledCard>

                        </form>
                    )
                    :
                    <CommonRestricted />
            }

            <Fab
                // size="small"
                color="primary"
                aria-label="add"
                sx={{
                    position: 'fixed',
                    bottom: 16,
                    right: 16,
                }}
                onClick={() => {
                    // console.log('aaa')
                    handleAddContainerItems()
                }}
                disabled={
                    Boolean(!savedValues?.sourceContainerRemId)
                }
            >
                <CommonIcons name={icons.plus} />
            </Fab>

            <Fab
                // size="small"
                color="error"
                disabled={
                    selectedIds.length <= 0
                }
                aria-label="remove"
                sx={{
                    position: 'fixed',
                    bottom: 78,
                    right: 16,
                }}
                onClick={() => {
                    // console.log('se', selectedIds)
                    handleDeleteContainerItems({ selectedProductIds: selectedIds })
                }}
            >
                <Badge
                    badgeContent={
                        selectedIds.length
                    }
                    color="warning"
                >
                    <CommonIcons name={icons.remove} />
                </Badge>
            </Fab>

            {/* Update Remark */}
            <Dialog
                open={dialogOpen}
                onClose={() => {
                    setDialogOpen(false)
                    setDialogParams({})
                }}
                maxWidth="false"
            >
                <div
                    style={{
                        width: 700
                    }}
                >
                    <DialogTitle>{t('updateRemark')}</DialogTitle>

                    <DialogContent>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="name"
                            name="remark"
                            label={t("remark")}
                            type="text"
                            multiline
                            value={dialogParams?.remark ? dialogParams.remark : ""}
                            onChange={(e) => {
                                setDialogParams({
                                    ...dialogParams,
                                    remark: e.target.value
                                })
                            }}
                            fullWidth
                            variant="standard"
                        />
                    </DialogContent>
                </div>

                <DialogActions>
                    <Button
                        onClick={
                            () => {
                                setDialogOpen(false)
                                setDialogParams({})
                            }
                        }
                    >
                        {t('cancel')}
                    </Button>
                    <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={async () => {
                            await updateProductRemarkIP({
                                productId: dialogParams?.productId,
                                remark: dialogParams?.remark
                            })

                            setDialogOpen(false)
                            setDialogParams({})

                            loadData(id)
                        }}
                    >
                        {t('saveChanges')}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Modify Load Container Date Time */}
            <Dialog
                open={dialogLoadContainerDTOpen}
                onClose={() => {
                    setDialogLoadContainerDTOpen(false)
                    setDialogLoadContainerDTParams({})
                }}
                maxWidth="false"
            >
                <div
                    style={{
                        width: 700
                    }}
                >
                    <DialogTitle>{t('modifyLoadContainerDateTime')}</DialogTitle>

                    <DialogContent>

                        {/* <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="loadContainerDateTime"
                            name="loadContainerDateTime"
                            label={t("loadContainerDateTime")}
                            type="text"
                            // multiline
                            value={dialogLoadContainerDTParams?.loadContainerDateTime ?
                                dayjs(dialogLoadContainerDTParams.loadContainerDateTime).format(`${_loadContainerDateTimeFormat} A`)
                                :
                                ""
                            }
                            onChange={(e) => {
                                setDialogLoadContainerDTParams({
                                    ...dialogLoadContainerDTParams,
                                    loadContainerDateTime: e.target.value
                                })
                            }}
                            fullWidth
                            variant="standard"
                        /> */}
                        <Box
                            sx={{
                                mt: 1
                            }}
                        >
                            <LocalizationProvider
                                dateAdapter={AdapterDayjs}
                            >
                                <DateTimePicker
                                    label={t("loadContainerDateTime")}
                                    views={['year', 'day', 'hours', 'minutes', 'seconds']}
                                    format={`${_loadContainerDateTimeFormat}`}
                                    // orientation="portrait"
                                    value={
                                        dialogLoadContainerDTParams?.loadContainerDateTime ?
                                            dayjs(dialogLoadContainerDTParams.loadContainerDateTime)
                                            :
                                            null
                                    }
                                    onChange={(newValue) => {
                                        setDialogLoadContainerDTParams({
                                            ...dialogLoadContainerDTParams,
                                            loadContainerDateTime: dayjs(newValue).format(_loadContainerDateTimeFormat)
                                        })
                                    }}
                                />
                            </LocalizationProvider>

                        </Box>

                    </DialogContent>
                </div>

                <DialogActions>
                    <Button
                        onClick={
                            () => {
                                setDialogLoadContainerDTOpen(false)
                                setDialogLoadContainerDTParams({})
                            }
                        }
                    >
                        {t('cancel')}
                    </Button>
                    <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={async () => {

                            await updateProductLoadContainerDT({
                                productId: dialogLoadContainerDTParams?.productId,
                                sourceProductRemId: dialogLoadContainerDTParams?.sourceProductRemId,
                                sourceContainerRemId: dialogLoadContainerDTParams?.sourceContainerRemId,
                                loadContainerDateTime: dialogLoadContainerDTParams?.loadContainerDateTime
                            })

                            setDialogLoadContainerDTOpen(false)
                            setDialogLoadContainerDTParams({})

                            loadData(id)

                        }}
                    >
                        {t('saveChanges')}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Load Proof of Delivery Info */}
            <Dialog open={proofOfDeliveryDialog} onClose={handleCloseProofDeliveryDialog} maxWidth={"md"} fullWidth sx={{ height: "auto", alignSelf: "center" }}>
                <DialogTitle sx={{ fontWeight: 600 }}>{t('proofOfDeliveryDetails')}</DialogTitle>

                <DialogContent>
                    {
                        (dataContainerPod.length > 0) ?
                            (
                                dataContainerPod?.map((item, index) => {
                                    return (
                                        <Timeline position="alternate" key={index}>
                                            <TimelineItem>
                                                <TimelineOppositeContent
                                                    sx={{ m: 'auto 0' }}
                                                    align="right"
                                                    variant="body2"
                                                    color="text.secondary"
                                                >
                                                    <Typography fontSize={15} fontWeight={600}>
                                                        {item?.createdatetime}
                                                    </Typography>
                                                </TimelineOppositeContent>

                                                <TimelineSeparator>
                                                    <TimelineConnector />
                                                    <TimelineDot>
                                                        <CommonIcons name={icons.burger} />
                                                    </TimelineDot>
                                                    <TimelineConnector />
                                                </TimelineSeparator>

                                                <TimelineContent sx={{ py: '12px', px: 2 }}>
                                                    <Typography fontSize={18} fontWeight={700} component="span">
                                                        {(item?.type).toUpperCase()}
                                                    </Typography>
                                                    <Typography> {item?.description}</Typography>
                                                </TimelineContent>

                                            </TimelineItem>
                                        </Timeline>
                                    )
                                })
                            ) : (
                                <Typography
                                    fontSize={25}
                                    fontWeight={600}
                                    color={grey[400]}
                                    textAlign={"center"}
                                    alignItems={"center"}
                                >
                                    {t('noProofDetailAtTheMoment')}
                                </Typography>
                            )
                    }
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseProofDeliveryDialog} color="secondary" variant='contained'>
                        {t('close')}
                    </Button>
                </DialogActions>
            </Dialog>

        </Box>
    )
}